import React, { memo } from 'react';
const defaultText = `© ${new Date().getFullYear()}, Apple Inc. All rights reserved. Apple Confidential.`;
export const FooterCopyright = memo(({ text = defaultText, className = 'copyright' }) => (React.createElement("span", { className: className }, text)));
